import * as store from '@attain-apps/fe/web/main/lib/store'

import type * as ecModels from '../../../../models'
import type { Plugin } from '../plugin'
import { State } from '../state'

export const resetOnContextChange = store.reducers.extra(
  <TTypeParams extends ecModels.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    new store.reducers.ExtraReducer({
      on: [plugin.collection.feature.actions.changeContext],
      reduce: (state: State<TTypeParams>) =>
        State.getInitialState(plugin.config),
    }),
)
